import { render, staticRenderFns } from "./AccountActivities.vue?vue&type=template&id=4fd5d5f2&"
import script from "./AccountActivities.vue?vue&type=script&lang=js&"
export * from "./AccountActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports